import React,{useEffect} from 'react';
import * as S from './Period.styles'
import classnames from 'classnames';
export const Period = ({data,updatePeriodData,periodData,classes,from,to})=>{
    if(!data || !Array.isArray(data)){
        return null;
    }
    useEffect(()=>{
        if(!periodData?.id){
            updatePeriodData(data?.[0])
    
        }
      },[])

useEffect(()=>{
if((!from || !to)&& (!periodData?.id)){
    updatePeriodData(data?.[0])
}
},[from,to])

    return(          <S.SelectPeriod>
        <h3>Select Period</h3>


        <ul className="periodOptions">
            {data?.map(({id,primaryText='',secondaryText=["",""]},index)=>{
               
                return (   <li className="periodOption" key={`periodOption${index}`}>
                <label htmlFor={id}>
                    <input
                        type="radio"
                        id={id}
                        name="period"
                        value={primaryText}
                        checked={periodData?.id === id}
                        onChange={(e)=>{
                            updatePeriodData(data[index])
                        }}
                    />

                    <div>
                        <p>
                           {primaryText}
                        </p>

                       {secondaryText[0] &&  <p className='date'>
                            <span>{secondaryText[0]}</span>

                            <span className={classnames(classes)} />
                         
                            <span>{secondaryText[1]}</span>
                        </p> }
                    </div>



                </label>

            </li>)

            })}
   
        
        </ul>
    </S.SelectPeriod>
)
}